import { Typography, List, ListItem, ListItemText, Alert, Box, Card, CardContent, Grid, Chip } from '@mui/material';
import SEO from 'features/shared/components/common/SEO';

export default function MantenimientoCDMX(){
  return (
    <>
      <SEO 
        title="Mantenimiento CDMX | Rolsys Solutions"
        description="Mantenimiento preventivo y correctivo de equipos de cómputo en Ciudad de México. Planes personalizados."
      />

      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Typography variant="h3" sx={{ fontWeight:800 }}>
            Mantenimiento
          </Typography>
          <Chip label="Solo CDMX" color="secondary" />
        </Box>

        <Alert severity="info" sx={{ mb: 4 }}>
          Servicio de mantenimiento disponible solo en Ciudad de México y área metropolitana.
        </Alert>

        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Card elevation={0} sx={{ border: '1px solid #eee', mb: 3 }}>
              <CardContent>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                  Mantenimiento preventivo
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText 
                      primary="Limpieza física y lógica"
                      secondary="Limpieza interna de equipos y optimización del sistema operativo"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Actualización de software"
                      secondary="Instalación de parches de seguridad y actualizaciones críticas"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Revisión de componentes"
                      secondary="Inspección de hardware y detección temprana de fallas"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Optimización de rendimiento"
                      secondary="Configuración para mejorar velocidad y estabilidad"
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>

            <Card elevation={0} sx={{ border: '1px solid #eee' }}>
              <CardContent>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                  Mantenimiento correctivo
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText primary="Reparación de fallas de hardware" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Solución de problemas de software" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Reemplazo de componentes defectuosos" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Recuperación de datos" />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card elevation={0} sx={{ border: '1px solid #eee' }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                  Planes de mantenimiento
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  <strong>Básico:</strong> Cada 6 meses
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  <strong>Estándar:</strong> Cada 3 meses
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  <strong>Premium:</strong> Mensual
                </Typography>
                <Typography variant="body2">
                  <strong>Empresarial:</strong> Personalizado según necesidades
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}